<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect" v-top-menu-scroll>
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/xihoumenSensorIndex">首页</el-menu-item>
        <el-submenu :index="'/xihoumenSensor/gasClamp'">
          <template slot="title">气夹实时数据</template>
          <el-menu-item index="/xihoumenSensor/gasClamp/upstream">舟向气夹实时数据</el-menu-item>
          <el-menu-item index="/xihoumenSensor/gasClamp/downstream">宁向气夹实时数据</el-menu-item>
        </el-submenu>
        <el-menu-item index="/xihoumenSensor/cableClamp">索夹实时数据</el-menu-item>
        <el-menu-item index="/xihoumenSensor/gasClamp/power">能耗实时数据</el-menu-item>
        <el-submenu :index="'/xihoumenSensor/station/main1'">
          <template slot="title">1#空气制备站(北塔)</template>
          <el-menu-item index="/xihoumenSensor/station/main1">1#制备站主机</el-menu-item>
          <el-menu-item index="/xihoumenSensor/station/vent1">1#制备站主机出口</el-menu-item>
          <el-menu-item index="/xihoumenSensor/station/backup1">1#制备站备机</el-menu-item>
          <el-menu-item index="/xihoumenSensor/station/ventBackup1">1#制备站备机出口</el-menu-item>
        </el-submenu>
        <el-submenu :index="'/xihoumenSensor/station/main2'">
          <template slot="title">2#空气制备站(南塔)</template>
          <el-menu-item index="/xihoumenSensor/station/main2">2#制备站主机</el-menu-item>
          <el-menu-item index="/xihoumenSensor/station/vent2">2#制备站主机出口</el-menu-item>
          <el-menu-item index="/xihoumenSensor/station/backup2">2#制备站备机</el-menu-item>
          <el-menu-item index="/xihoumenSensor/station/ventBackup2">2#制备站备机出口</el-menu-item>
        </el-submenu>
        <!-- <el-submenu :index="'/xihoumenSensor/valveClamp'">
            <template slot="title">气夹阀门</template>
            <el-menu-item index="/xihoumenSensor/valveClamp/upstream">舟向气夹阀门</el-menu-item>
            <el-menu-item index="/xihoumenSensor/valveClamp/downstream">宁向气夹阀门</el-menu-item>
          </el-submenu> -->
        <el-menu-item index="/xihoumenSensor/currentDataTable?bridgeId=3aeeb5b1-f586-43c4-b03c-2e5880d2e541">实时数据表</el-menu-item>
        <el-menu-item index="/xihoumenSensor/errorRecord?bridgeId=3aeeb5b1-f586-43c4-b03c-2e5880d2e541">报警记录</el-menu-item>
        <el-submenu :index="'/xihoumenSensor/dataHistory?bridgeId=3aeeb5b1-f586-43c4-b03c-2e5880d2e541&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/xihoumenSensor/dataHistory?bridgeId=3aeeb5b1-f586-43c4-b03c-2e5880d2e541&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/xihoumenSensor/dataHistory?bridgeId=3aeeb5b1-f586-43c4-b03c-2e5880d2e541"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="ZHOUSHAN" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main xi-hou-men">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
import topMenuScroll from "../../tools/TopMenuScroll.js";

export default {
  name: "xihoumenSensor",
  data() {
    return {
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",
      envInfo: {
        envId: "35cf8773-4961-45f7-80d2-c1c844d7893a",
        weather: "b7afc517-f448-4a85-9b84-1a122cc06127",
        humidity: "866fb39e-0805-425e-b399-5994f7892a84",
        temperature: "b66c3cb6-35d2-4561-86bf-0c85265173b7",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  directives: {
    topMenuScroll,
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>
